import { BACKGROUND_MASK_NAME } from '@/infrastructure/engine2d/fabricGroupsName';
import { MASK_MARGIN_PX } from '@/infrastructure/engine2d/engine2dConstants';
import { Canvas, Path, Rect } from 'fabric';

/**
 * Build a mask that cover all the canvas except the content area. It use path with evenodd fill rule to create a hole with sharp (not blurred) edges.
 */
function buildMaskPath(content: Rect, options: object = {}) {
    const INF = 100000;
    const x = Math.floor(content.left + MASK_MARGIN_PX);
    const y = Math.floor(content.top + MASK_MARGIN_PX);
    const w = Math.floor(content.getScaledWidth() - MASK_MARGIN_PX * 2);
    const h = Math.floor(content.getScaledHeight() - MASK_MARGIN_PX * 2);

    return new Path(
        `
    M ${-INF} ${-INF}
    H ${INF}
    V ${INF}
    H ${-INF}
    Z
    M ${x} ${y}
    H ${x + w}
    V ${y + h}
    H ${x}
    Z
    `,
        {
            ...options,
            selectable: false,
            evented: false,
            absolutePositioned: true,
            fillRule: 'evenodd',
            objectCaching: false,
        },
    );
}

function setBackgroundMaskVisibility(fabricCanvas: Canvas, opacity: number) {
    const bgMask = fabricCanvas.getObjects().find((o) => o.get('id') === BACKGROUND_MASK_NAME);
    if (bgMask) {
        bgMask.opacity = opacity;
    }
}

export { buildMaskPath, setBackgroundMaskVisibility };
